import api from 'api/apiInstance';

export function adviserResendApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
